import {getLinkProps} from '~/cms/components/LinkComponent'
import {type HgIconType} from '~/design-system/hg/components'
import {HgArticleWYSIWYGAside} from '~/design-system/hg/components/HgWYSIWYG/Article/_components'
import {WYSIWYGSingleLineStructuredText} from '../../../../WYSIWYG/_components/WYSIWYGSingleLineStructuredText'
import {ArticleAsideAccompanyingBlock} from '../ArticleAsideAccompanyingBlock'
import {type ArticleAsideFragment} from './_generated/fragment.graphql'

type DatoWYSIWYGAsideProps = ArticleAsideFragment

export const DatoWYSIWYGAside = ({
  icon,
  title,
  subhead,
  link,
  accompanyingBlock,
}: DatoWYSIWYGAsideProps) => {
  return (
    <HgArticleWYSIWYGAside
      iconType={icon?.iconType as HgIconType}
      title={title && <WYSIWYGSingleLineStructuredText data={title} />}
      subhead={<WYSIWYGSingleLineStructuredText data={subhead} />}
      linkProps={getLinkProps(link)}
      accompanyingBlock={<ArticleAsideAccompanyingBlock data={accompanyingBlock} />}
    />
  )
}
